export enum EventType {
  PAGE_VIEW = 'Page View',
  INTERACTION = 'Interaction',
  IMPRESSION = 'Impression',
  OUTCOME = 'Outcome',
}

export type ClickstreamEvent = {
  event_name: string;
  event_type: string;
  clickstream_trace_id?: string;
  action_location?: string;
  event_producer?: string;
  event_category: string;
};

export type FormEventContext = {
  form_id: string;
  form_redirect_url: string;
};

export type LoginEventContext = {
  form?: FormEventContext;
  error_list?: ErrorEventContext[];
  user?: UserEventContext;
};

export type UserEventContext = {
  eg_account_id: string;
  brand_customer_id: string;
  partner_account_id: string;
};

export type ClickstreamPayload = {
  event: ClickstreamEvent;
  experience: ClickstreamExperience;
  affhub_constext?: AffhubContext;
  [key: string]: unknown;
};

export type ClickstreamExperience = {
  page_name: string;
  page_name_detailed?: string;
  page_product_line?: string;
};

export type ErrorEventContext = {
  error_name: string;
  error_code?: string;
  error_description?: string;
};

export type AffhubContext = {
  app_location?: string;
  program?: ProgramContext;
  product?: ProductContext;
  link?: LinkContext;
};

export type ProgramContext = {
  program_id: string;
  program_name: string;
};

export type ProductContext = {
  product_name?: string;
};

export type LinkContext = {
  link_type: string;
  link_index: number;
  link_target_url: string;
};
